import { render, staticRenderFns } from "./ProcessTemplate.vue?vue&type=template&id=370aa171&scoped=true"
import script from "./ProcessTemplate.vue?vue&type=script&lang=js"
export * from "./ProcessTemplate.vue?vue&type=script&lang=js"
import style0 from "./ProcessTemplate.vue?vue&type=style&index=0&id=370aa171&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370aa171",
  null
  
)

export default component.exports